import { PageWrapper } from '@components/Dashboard/components'
import { useWorkspaces } from '@components/Dashboard/hooks'
import { getLeaveAction } from '@components/Dashboard/utils'
import type { ID } from '@octopus-do/octopus-project-core'
import { DashboardActions } from '@store/reducers/dashboard/actions'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { useAuth } from '@/hooks'
import { clsJoin } from '@/utils'
import { InviteCard, LeaveTeamCard, TeammatesList } from './components'
import { useMembersList } from './hooks'
import css from './styles.module.css'

export const MembersList: React.FC = () => {
  const dispatch = useDispatch()
  const { current } = useWorkspaces()
  const auth = useAuth()

  const features = current?.features || []
  const id = current?.id as ID

  const { onClick: onMemberClick } = useMembersList(id)

  const canLeave = features.includes('leave_team')
  const canInvite = features.includes('members_invite')
  const listDisabled = !features.includes('members_edit')

  const onInvite = (email: string) =>
    dispatch(DashboardActions.members.invite({ email, workspaceId: id }))

  const onLeave = () => dispatch(getLeaveAction(id))

  if (!current) {
    return null
  }

  return (
    <div className={clsJoin(css.responsive, css.content)}>
      <PageWrapper title="Members">
        <TeammatesList
          authId={auth.id}
          disabled={listDisabled}
          onClick={onMemberClick}
          members={current.members}
        />

        {canInvite && <InviteCard onInvite={onInvite} />}
      </PageWrapper>

      {canLeave && <LeaveTeamCard title={current.title} onClick={onLeave} />}
    </div>
  )
}
